import React from 'react';
import RenderContent from 'app/components/layout/RenderContent';
import Button from 'app/components/general/Button';
import history from 'app/routes/history';
import MaintenanceImage from 'app/images/404.png';

interface IProps {
  match: any;
}
export default class Maintenance extends React.Component<IProps> {
  render(): React.ReactNode {
    return (
      <RenderContent className="my-dashboard-app" match={this.props.match}>
        <div className="container d-flex flex-grow">
          <div className="row flex-grow">
            <div className="col d-flex flex-grow text-center align-items-center justify-content-center">
              <div>
                <h1>We are currently performing system maintenance - sorry!</h1>
                <div className="with-margin-top">
                  Please refer to
                  {' '}
                  <a href="https://status.teammo.com.au/">status.teammo.com.au</a>
                  {' '}
                  for more information.
                </div>
              </div>
            </div>
          </div>
        </div>
      </RenderContent>
    );
  }
}
